import { Dispatch } from "redux";
import { Action, ActionType } from "../actions";
import PluginService from "../../services/pluginService";
import { IDefaultValues, IPluginConfiguration } from "../../models/configuration/plugin/IConfiguration";
import { hasPluginConfigChanges } from "../../utils/pluginConfigChangeDetector";

// This action creator gets the server config values from an api call or state
const saveConfigMiscData = (configId: string, updatedMiscDefaultData: IDefaultValues, token: string | null) => {
    return async (dispatch: Dispatch<Action>, getState: () => any) => {

        dispatch({ type: ActionType.SAVE_CONFIG_PLUGIN_DATA });

        try {

            const { data: pluginConfiguration, persistedData } = getState().configPlugInData;

            if (!pluginConfiguration) {
                throw new Error(" No PluginConfiguration available in state to save");
            }

            if (!updatedMiscDefaultData) {
                throw new Error("No Misc Defaults to save");
            }

            // Using the Plug In State Data update the Misc Defaults
            const updatedConfig = {
                ...pluginConfiguration.Configuration,
                DefaultValues: updatedMiscDefaultData
            }

            const hasChanges = hasPluginConfigChanges(updatedConfig, persistedData?.Configuration);
            if (!hasChanges) {
                dispatch({
                    type: ActionType.SAVE_CONFIG_PLUGIN_DATA_SUCCESS,
                    payload: { "Configuration": updatedConfig }
                });
                return false;
            }

            const configToSave = {
                ...updatedConfig,
                LastUpdateUtc: new Date().toISOString()
            };

            const requestBody = {
                "ConfigurationId": configId,
                "EncompassInstanceId": getState().appSlice.encompassInstanceId,
                "Configuration": configToSave
            }

            await new PluginService().saveEpcApiConfig<IPluginConfiguration>(token, "plugin", configId, requestBody);

            dispatch({
                type: ActionType.SAVE_CONFIG_PLUGIN_DATA_SUCCESS,
                payload: { "Configuration": configToSave }
            });
            dispatch({
                type: ActionType.SAVE_CONFIG_PLUGIN_DATA_PERSISTED,
                payload: { "Configuration": configToSave }
            });

            return true;

        } catch (error: any) {
            console.error("Save Misc Defaults Data");
            const payloadErrorMessage = `Failed to save Misc Defaults Data: (${error.message})`;
            dispatch({
                type: ActionType.SAVE_CONFIG_PLUGIN_DATA_FAILURE,
                payload: payloadErrorMessage,
            });
            return Promise.reject(payloadErrorMessage);
        }
    }
}

export default saveConfigMiscData;